module.exports = "##### Yellow\n"